import React from "react";
import {
  Card,
  CardHeading,
  CardSubHeading
} from "styles/pages/web-checkout.styles";
import Head from "next/head";
import { useRouter } from "next/router";
import { useAuth } from "stores/auth/auth-context";
import { LoginBackground } from "components/web-checkout/login-background/login-background";
import { UserProfileForm } from "components/web-checkout/user-profile-form/user-profile-form";

const UserDetailsPage = (): JSX.Element => {
  const router = useRouter();
  const { user } = useAuth();
  const { userType } = user.userData;

  return (
    <LoginBackground routerPath={router.pathname} prevLink="/user/select-role">
      <Head>
        <title>CoLearn | Buat profil baru</title>
      </Head>
      <Card>
        <CardHeading>Selamat datang di CoLearn!</CardHeading>
        <CardSubHeading>
          {userType === "student"
            ? "Lengkapi informasi di bawah ini biar proses belajarmu lebih maksimal"
            : "Untuk membantu proses belajar anak Anda, lengkapi informasi di bawah ini"}
        </CardSubHeading>

        <UserProfileForm userType={userType} />
      </Card>
    </LoginBackground>
  );
};

export default UserDetailsPage;

UserDetailsPage.requireAuth = true;
